import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Edit2, Globe, Search } from 'react-feather';
import config from '../../../../config';
import useEntityCrud from '../shared/useEntityCrud';
import KpiStrip from '../shared/KpiStrip';
import Pagination from '../shared/Pagination';

const CountriesTab = ({ q, page, onPageChange, onEdit, onAdd, canManage, reloadKey }) => {
    const { t } = useTranslation();
    const concessionaireId = localStorage.getItem('concessionaireId');

    const { paged, total, pageCount, page: safePage, loading } = useEntityCrud({
        endpoint: `${config.hostname}/country/getcountrybyconcessionaire`,
        payload: { country_concessionaire_id: concessionaireId },
        searchFields: ['country_name', 'country_code', 'country_currency'],
        q,
        page,
        pageSize: 15,
        dependencies: [reloadKey],
    });

    const tiles = useMemo(() => ([
        { label: 'Total countries', value: total, icon: <Globe size={16} />, tone: 'accent' },
    ]), [total]);

    return (
        <>
            <KpiStrip tiles={tiles} />
            <div className="v3-card v3-sadmin-list-card">
                <div className="v3-sadmin-list-header">
                    <div className="v3-sadmin-list-title">
                        <h2 className="v3-title">{t('Countries')}</h2>
                        <span className="v3-sadmin-list-count">{total}</span>
                    </div>
                    <div className="v3-sadmin-list-actions">
                        {canManage && (
                            <button type="button" className="v3-btn v3-btn-primary" onClick={onAdd}>
                                + {t('Add country')}
                            </button>
                        )}
                    </div>
                </div>
                <div className="v3-sadmin-table-wrap">
                    {loading ? (
                        <div className="v3-sadmin-empty"><p>{t('Loading countries…')}</p></div>
                    ) : total === 0 ? (
                        <div className="v3-sadmin-empty">
                            <Search size={28} />
                            <h3>{t('No countries found')}</h3>
                            <p>{q ? t('Try clearing the search.') : t('Add your first country to get started.')}</p>
                        </div>
                    ) : (
                        <table className="v3-sadmin-table">
                            <thead>
                                <tr>
                                    <th>{t('Country')}</th>
                                    <th>{t('Code')}</th>
                                    <th>{t('Currency')}</th>
                                    {canManage && <th style={{ width: 80 }}>{t('Actions')}</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {paged.map((row) => (
                                    <tr key={row._id} onClick={() => canManage && onEdit(row._id)}>
                                        <td className="v3-sadmin-cell-strong">{row.country_name}</td>
                                        <td><span className="v3-sadmin-cell-code">{row.country_code}</span></td>
                                        <td className="v3-sadmin-cell-muted">{row.country_currency}</td>
                                        {canManage && (
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <div className="v3-sadmin-row-actions">
                                                    <button
                                                        type="button"
                                                        className="v3-sadmin-icon-btn"
                                                        onClick={() => onEdit(row._id)}
                                                        aria-label={t('Edit')}
                                                    >
                                                        <Edit2 size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <Pagination
                    page={safePage}
                    pageCount={pageCount}
                    total={total}
                    pageSize={15}
                    onPageChange={onPageChange}
                />
            </div>
        </>
    );
};

export default CountriesTab;
